import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseService } from "src/app/base/services/base.service";
import { PlanoAcao } from "../models/plano-acao.model";
import { Observable } from "rxjs";

@Injectable()
export class PontoCriticoAcaoService extends BaseService<PlanoAcao>{

  constructor(public http: HttpClient) {
    super(http);
  }

  public getByIdStatus(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list-status', { headers: this.headers });
  }

  public getByIdEntregaStatus(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/entrega-list-status', { headers: this.headers });
  }

  public getByIdIndicadorStatus(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/indicador-list-status', { headers: this.headers });
  }

  public getByIdSimple(id: number): Observable<PlanoAcao> {
    return this.http.get<PlanoAcao>(this.baseUrl + '/simplificada/' + id, { headers: this.headers });
  }

  public getByIdEntrega(id: number): Observable<PlanoAcao> {
    return this.http.get<PlanoAcao>(this.baseUrl + '/entrega/' + id, { headers: this.headers });
  }

  public getByIdIndicador(id: number): Observable<PlanoAcao> {
    return this.http.get<PlanoAcao>(this.baseUrl + '/indicador/' + id, { headers: this.headers });
  }

  public getByIdAgregadorIndicador(id: number): Observable<PlanoAcao> {
    return this.http.get<PlanoAcao>(this.baseUrl + '/agregador-indicador/' + id, { headers: this.headers });
  }

  public getByIdEntregaSimple(id: number): Observable<PlanoAcao> {
    return this.http.get<PlanoAcao>(this.baseUrl + '/entrega-simplificada/' + id, { headers: this.headers });
  }

  public getByIdIndicadorSimple(id: number): Observable<PlanoAcao> {
    return this.http.get<PlanoAcao>(this.baseUrl + '/indicador-simplificada/' + id, { headers: this.headers });
  }

  public getByIdAgregadorIndicadorSimple(id: number): Observable<PlanoAcao> {
    return this.http.get<PlanoAcao>(this.baseUrl + '/agregador-indicador-simplificada/' + id, { headers: this.headers });
  }

  public entregaCreate(obj: PlanoAcao): Observable<PlanoAcao> {
    return this.http.post<PlanoAcao>(this.baseUrl + '/entrega', obj, { headers: this.headers });
  }

  public indicadorCreate(obj: PlanoAcao): Observable<PlanoAcao> {
    return this.http.post<PlanoAcao>(this.baseUrl + '/indicador', obj, { headers: this.headers });
  }

  public agregadorIndicadorCreate(obj: PlanoAcao): Observable<PlanoAcao> {
    return this.http.post<PlanoAcao>(this.baseUrl + '/agregador-indicador', obj, { headers: this.headers });
  }

  public entregaUpdate(obj: PlanoAcao, id: number): Observable<PlanoAcao> {
    return this.http.put<PlanoAcao>(this.baseUrl + '/entrega/' + id, obj, { headers: this.headers });
  }

  public indicadorUpdate(obj: PlanoAcao, id: number): Observable<PlanoAcao> {
    return this.http.put<PlanoAcao>(this.baseUrl + '/indicador/' + id, obj, { headers: this.headers });
  }

  public agregadorIndicadorUpdate(obj: PlanoAcao, id: number): Observable<PlanoAcao> {
    return this.http.put<PlanoAcao>(this.baseUrl + '/agregador-indicador/' + id, obj, { headers: this.headers });
  }

  public entregaDelete(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + '/entrega/' + id, { headers: this.headers });
  }

  public indicadorDelete(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + '/indicador/' + id, { headers: this.headers });
  }

  public agregadorIndicadorDelete(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + '/agregador-indicador/' + id, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/projetos/ponto-critico-acao';
  }

}